(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["source-photo-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initRatingButtons = root => {
    if (root.dataset.ratingButtonsReady) return;
    const filter = root.querySelector('[data-photo-review-filter]');
    const buttons = [...root.querySelectorAll('[data-photo-review-rating]')];
    if (!filter || !buttons.length) return;
    root.dataset.ratingButtonsReady = 'true';
    const syncRatingButtons = () => buttons.forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.photoReviewRating === filter.value));
    });
    const applyRating = value => {
      filter.value = value;
      filter.dispatchEvent(new Event('change', { bubbles: true }));
      root.querySelector('.photo-reviews-tools')?.scrollIntoView({ block: 'start', behavior: 'instant' });
    };
    buttons.forEach(button => button.addEventListener('click', () => applyRating(button.dataset.photoReviewRating)));
    filter.addEventListener('change', syncRatingButtons);
    syncRatingButtons();
  };
  const init = scope => scope.querySelectorAll('[data-photo-reviews]').forEach(initRatingButtons);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
